import type { Chat } from '../../services/chatAdministrationApi';
import type { FleetGroupTag } from '../../services/tagsApi';

export const matchesSelectedFleetGroups = (chat: Pick<Chat, 'tagIds'> | undefined, selectedTagIds: string[]) => {
    if (selectedTagIds.length === 0) {
        return true;
    }

    return !!chat?.tagIds.some(tagId => selectedTagIds.includes(tagId));
};

export const getAvailableFleetGroupTags = (chats: Chat[], tags: FleetGroupTag[] = []): FleetGroupTag[] => {
    const tagsById = new Map(tags.map(tag => [tag.id, tag]));
    const assignedTagIds = new Set(chats.flatMap(chat => chat.tagIds));

    return Array.from(assignedTagIds)
        .map(tagId => tagsById.get(tagId) ?? { id: tagId, name: tagId })
        .sort((a, b) => a.name.localeCompare(b.name));
};

export const getValidSelectedFleetGroupTagIds = (chats: Chat[], selectedTagIds: string[]) => {
    const assignedTagIds = new Set(chats.flatMap(chat => chat.tagIds));

    return selectedTagIds.filter(tagId => assignedTagIds.has(tagId));
};

export const filterChatsByFleetGroups = (chats: Chat[], selectedTagIds: string[]) =>
    chats.filter(chat => matchesSelectedFleetGroups(chat, selectedTagIds));
